<template>
    <div class="TQ_center">

        <!-- 1) Creator data  -->
        <tq-loader-container :p_tq-loader_b="true" :p_show-loader_b="server_creatorData_c == null">
            <div class="TQ_box_shadow TQ_padding_12px TQ_textAlign_initial TQ_bg_white TQ_maxWidth_500px TQ_inline TQ_margin_12px TQ_borderRadius TQ_width_100p" v-if="server_creatorData_c">

                <div class="">

                    <div class="TQ_center">
                        <tq-avatar :p_ud_avatar_c="server_creatorData_c.ud_avatar_c"
                                   class="TQ_width_200px TQ_box_shadow2 TQ_bg_circle"/>


                        <div class="TQ_margin_4px">
                            <div class="TQ_text_20px TQ_text_bold">
                                {{ass_strings.oneWord_level[store_system_langCode_ve.val]}} {{ server_creatorData_c.ud_m_level_s() }}
                            </div>

                            <div class="">
                                {{server_creatorData_c.ud_levelTotalPoints_n}} {{ass_strings.oneWord_points[store_system_langCode_ve.val]}}
                            </div>

                        </div>

                    </div>

                    <div class="TQ_margin_8px TQ_grid_verticalCenter">

                        <hr>

                        <div :class="{'TQ_grid_col_Auto1frAuto' : store_system_windowSizeType_ve.val > enum_screenSizesOptions_n.mobile}">
                            <div class="TQ_text_24px TQ_textColor_purple_dark TQ_text_bold TQ_grid_verticalCenter">
                                {{server_creatorData_c.ud_name_s}}
                            </div>

                            <div></div> <!-- space -->

                            <div>

                                <!-- phone number -->
                                <div class="TQ_box_shadow TQ_padding_8px TQ_grid_verticalCenter TQ_bg_green TQ_clickable TQ_inline TQ_borderRadius TQ_margin_4px"
                                     v-if="!showCreatorPhoneNumber_b"
                                     @click="showCreatorPhoneNumber_b = true">
                                    {{ass_strings.oneWord_phone[store_system_langCode_ve.val]}}
                                </div>
                                <div v-else-if="server_creator_uds_moreInfo_c" class="TQ_inline TQ_padding_8px">
                                    <a :href="'tel:+972-' + server_creator_uds_moreInfo_c.udsmi_phone_s">
                                        {{server_creator_uds_moreInfo_c.udsmi_phone_s}}
                                    </a>
                                </div>

                                <!-- email address-->
                                <div class="TQ_box_shadow TQ_padding_8px TQ_grid_verticalCenter TQ_bg_gold TQ_clickable TQ_inline TQ_borderRadius TQ_margin_4px"
                                     @click="showPopup_sendEmail_vb.val = true">
                                    {{ass_strings.oneWord_message[store_system_langCode_ve.val]}}
                                </div>

                            </div>

                        </div>

                        <hr>

                        <tq-long-text
                            v-if="server_creator_uds_moreInfo_c"
                            :pb_max-length_n="500"
                            :pb_text_s="server_creator_uds_moreInfo_c.udsmi_cm_about_fs(store_system_langCode_ve.val)"
                            :ps_lang-code_e="store_system_langCode_ve.val"/>
                    </div>
                </div>

            </div>
        </tq-loader-container>
        
        <!-- -->
        <tq-card width="100%" margin="8px" max-width="350px" :selectable="true"
                 v-for="(questExplore_c, index_n) in co_arrangeQuestsExplore_ac" :key="index_n">

            <tq-quest-explore-header
                    :pb_created-user-data_c="server_creatorData_c"
                    :pb_quest-explore-info_c="server_questExploreInfo_byQuestId_c[questExplore_c.qex_questId_uid]"
                    :pb_quest-explore_c="questExplore_c"

                    :ps_lang-code_e="store_system_langCode_ve.val"
                    :p_system_current-currency_e="store_system_currency_ve.val"
                    :ps_screenSize_en="store_system_windowSizeType_ve.val"

                    :pf_loved-quest_b="server_currentUserLovedQuests_byQuestId_c[questExplore_c.qex_questId_uid] != null"
                    :pf_small-mode_b="true"

                    :pe_click-heart_fe="() => {}"

                    @click.native="() => {m_clickQuestExplore_f(questExplore_c)}"
            />

        </tq-card>

        <!-- popup send email -->
        <tq-popup :show="showPopup_sendEmail_vb" max-width="350px" :show-close-btn="true">

            <div class="TQ_padding_16px">

                <!-- 0) title -->
                <div class="TQ_text_24px  TQ_border_bottom">
                    {{ass_strings.twoWords_sendEmail[store_system_langCode_ve.val]}}
                </div>
                <div class="TQ_padding_8px"></div><!-- space -->

                <!-- 1) name -->
                <div class="TQ_align_initial TQ_text_bold">
                    {{ass_strings.oneWord_name[store_system_langCode_ve.val]}}
                </div>
                <tq-textarea
                    class=""
                    pb_uid_s="fullName"
                    pb_textarea-class_s="TQ_padding_4px"
                    pb_init-text_s=""
                    :pb_max-length_n="20"
                    :pb_placeholder_s="ass_strings.twoWords_yourName[store_system_langCode_ve.val]"
                    :pb_rows_n="1"
                    :pe_change-text_s="(text_s) => {sendEmail_name = text_s}"
                />

                <!-- 2) email -->
                <div class="TQ_align_initial TQ_text_bold">
                    {{ass_strings.oneWord_email[store_system_langCode_ve.val]}}
                </div>
                <tq-textarea
                    pb_uid_s="fullName"
                    pb_textarea-class_s="TQ_padding_4px"
                    pb_init-text_s=""
                    :pb_max-length_n="40"
                    :pb_placeholder_s="ass_strings.sentence_emailAddressReply[store_system_langCode_ve.val]"
                    :pb_rows_n="1"
                    :pe_change-text_s="(text_s) => {sendEmail_email = text_s}"
                />

                <!-- 3) phone -->
                <div class="TQ_align_initial TQ_text_bold">
                    {{ass_strings.twoWords_phoneNumber[store_system_langCode_ve.val]}}
                </div>
                <tq-textarea
                    pb_uid_s="fullName"
                    pb_textarea-class_s="TQ_padding_4px"
                    pb_init-text_s=""
                    :pb_max-length_n="10"
                    :pb_placeholder_s="ass_strings.twoWords_phoneNumber[store_system_langCode_ve.val]"
                    :pb_rows_n="1"
                    :pe_change-text_s="(text_s) => {sendEmail_phone = text_s}"
                />

                <!-- 4) msg -->
                <div class="TQ_align_initial TQ_text_bold">
                    {{ass_strings.oneWord_message[store_system_langCode_ve.val]}}
                </div>
                <tq-textarea
                    class="TQ_margin_bottom_8px"
                    pb_uid_s="fullName"
                    pb_textarea-class_s="TQ_padding_4px"
                    pb_init-text_s=""
                    :pb_max-length_n="500"
                    :pb_placeholder_s="ass_strings.twoWords_yourMessage[store_system_langCode_ve.val] +'...'"
                    :pb_rows_n="10"
                    :pe_change-text_s="(text_s) => {sendEmail_msg = text_s}"
                />

                <tq-loader-button :show-loader="btn_showLoader_b">
                    <div class="TQ_padding_8px TQ_margin_top_8px TQ_bg_purple TQ_text_20px TQ_clickable" @click="m_sendEmailToCreator_f">
                        {{ass_strings.twoWords_sendEmail[store_system_langCode_ve.val]}}
                    </div>
                </tq-loader-button>

            </div>

        </tq-popup>


    </div>
</template>

<script>
    import {route_moveToRoute, route_urlLastPath_fs} from "../../../router";
    import {
        serverAuth_getOtherUserData_f,
        serverAuth_getOtherUserData_withEmail_fp
    } from "../../../scripts/Server/S_ServerAuth";
    import TqImage from "../../../components/basic/TqImage";
    import TqLongText from "../../../components/basic/TqLongText";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {store_getStateValue_vo, store_var} from "../../../store";
    import {enum_moveToOptions, enum_screenSizesOptions_n, enum_urlParams} from "../../../../functions/src/shareCode/Share_S_Enum";
    import {ass_img_user_b} from "../../../assets/scripts/Ass_Files";
    import {
        server_getQuestExploreInfo_f, server_sendMail_fp,
        serverPre_cl_currentUserLovedQuests_get_f,
        serverPre_cl_currentUserLovedQuests_remove_f,
        serverPre_subUserData_moreInfo_get_f
    } from "../../../scripts/Server/S_ServerPre";
    import {serverBig_getQuestsExplore_filterByCreatorId_f} from "../../../scripts/Server/S_ServerFirestore";
    import TqCard from "../../../components/basic/TqCard";
    import TqQuestExploreHeader from "../../../components/complex/TqQuestExploreHeader";
    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";
    import TqAvatar from "@/components/complex/TqAvatar";
    import {seo_updateDynamicValues_f} from "@/scripts/S_seo";
    import TqPopup from "@/components/basic/TqPopup";
    import TqTextarea from "@/components/basic/TqTextarea";
    import TqLoaderButton from "@/components/basic2/TqLoaderButton";
    import {FB_SendEmail, FB_UserData} from "../../../../functions/src/shareCode/Share_S_Classes";
    import {notification_notify} from "@/scripts/S_Notification";

    export default {
        name: "v_Player_Store_Creator",
        components: {
            TqLoaderButton,
            TqTextarea, TqPopup, TqAvatar, TqLoaderContainer, TqQuestExploreHeader, TqCard, TqLongText, TqImage},
        data(){
            return {

                showCreatorPhoneNumber_b : false,

                sendEmail_name : false,
                sendEmail_email : false,
                sendEmail_phone : false,
                sendEmail_msg : false,
                showPopup_sendEmail_vb : {val : false},
                btn_showLoader_b : false,

                // server
                server_creatorData_c : null,
                server_creator_uds_moreInfo_c : null,
                server_questsExplore_ac : [],
                server_questExploreInfo_byQuestId_c : {},
                server_currentUserLovedQuests_byQuestId_c : {},

                // store
                store_system_currency_ve : store_getStateValue_vo(store_var.system_currency),
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),
                store_system_windowSizeType_ve : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // import
                ass_strings : ass_strings,
                enum_screenSizesOptions_n : enum_screenSizesOptions_n,
                ass_img_user_b : ass_img_user_b,
            }
        },
        computed:{
            co_arrangeQuestsExplore_ac(){

                return this.server_questsExplore_ac.sort((questExplore1_c, questExplore2_c) => {

                    if(questExplore1_c.qex_metadata_c.qeam_closedQuest_b){
                        return 1
                    }

                    if(questExplore2_c.qex_metadata_c.qeam_closedQuest_b){
                        return -1
                    }

                    let questExploreInfo1_c = this.server_questExploreInfo_byQuestId_c[questExplore1_c.qex_questId_uid]
                    let questExploreInfo2_c = this.server_questExploreInfo_byQuestId_c[questExplore2_c.qex_questId_uid]

                    if(!questExploreInfo1_c || !questExploreInfo2_c){
                        return 0
                    }


                    if(questExploreInfo1_c.qexi_participated_n > questExploreInfo2_c.qexi_participated_n){
                        return -1
                    }

                    if(questExploreInfo2_c.qexi_participated_n > questExploreInfo1_c.qexi_participated_n){
                        return 1
                    }

                    if(Math.round(questExploreInfo1_c.qexi_overallRatingAvg_n) > Math.round(questExploreInfo2_c.qexi_overallRatingAvg_n)){
                        return -1
                    }

                    if(Math.round(questExploreInfo2_c.qexi_overallRatingAvg_n) > Math.round(questExploreInfo1_c.qexi_overallRatingAvg_n)){
                        return 1
                    }


                    return 0



                })
            }
        },
        methods:{
            m_clickQuestExplore_f(questExplore_c){
                route_moveToRoute(enum_moveToOptions.player_store_quest + "/" + questExplore_c.qex_questId_uid,)
            },
            m_sendEmailToCreator_f(){

                this.btn_showLoader_b = true

                let msg_s   = "<pre>" + this.sendEmail_msg + "</pre>"
                let questName_s  = "<div> Quest: "  + this.server_questExplore_c.qex_name_byLangCode_s[this.co_qex_displayLangCode_s] + "</div>"
                let name_s  = "<div> Name: "  + this.sendEmail_name + "</div>"
                let email_s = "<div> Email: " + this.sendEmail_email + "</div>"
                let phone_s = "<div> Phone: " + this.sendEmail_phone + "</div>"

                let sendEmail_c = new FB_SendEmail({
                    se_sendToEmail_s: this.server_creatorData_c.ud_email_s,
                    se_title_s      : ass_strings.threeWords_receivedMsgFrom[this.store_system_langCode_v.val] + " " + this.sendEmail_name,
                    se_message_s    : msg_s + name_s + email_s + phone_s + questName_s,
                })

                server_sendMail_fp(sendEmail_c).then( () => {
                    this.btn_showLoader_b = false
                    this.showPopup_sendEmail_vb.val = false
                    notification_notify(ass_strings.twoWords_sentEmail)
                })

            },

        },

        async activated(){
            let creatorEmail_s = route_urlLastPath_fs()
            creatorEmail_s = FB_UserData.ud_m_s_getEmailFromUrl_fs(creatorEmail_s)

            this.server_creatorData_c = null
            this.server_questsExplore_ac = []

            let creatorData_c = await serverAuth_getOtherUserData_withEmail_fp(creatorEmail_s)


            if(creatorData_c == null){
                return
            }

            this.server_creatorData_c = creatorData_c

            // get user more info
            serverPre_subUserData_moreInfo_get_f({userId_uid: creatorData_c.ud_userId_uid, cb_f: (userMoreData_c)=> {
                    this.server_creator_uds_moreInfo_c = userMoreData_c

                    seo_updateDynamicValues_f({
                        title_s         : creatorData_c.ud_name_s,
                        description_s   : userMoreData_c.udsmi_cm_about_fs(this.store_system_langCode_ve.val),
                        imagePath_s     : creatorData_c.ud_avatar_c.cuda_avatarImage_b ? creatorData_c.ud_avatar_c.cuda_imgFile_c.fi_url_s : null
                    })

                }})

            // get all quests
            serverBig_getQuestsExplore_filterByCreatorId_f(creatorData_c.ud_userId_uid, true, (questExplore_ac) => {
                this.server_questsExplore_ac = questExplore_ac

                questExplore_ac.forEach(questExplore_c => {
                    server_getQuestExploreInfo_f(questExplore_c, (questExploreInfo_c) => {
                        this.$set(this.server_questExploreInfo_byQuestId_c, questExploreInfo_c.qexi_questId_uid, questExploreInfo_c)
                    })
                })
            })

            // 2) get currentUserLovedQuests
            serverPre_cl_currentUserLovedQuests_get_f(this.$options.name, creatorData_c,
                (questPointer_c) => {
                    this.$set(this.server_currentUserLovedQuests_byQuestId_c, questPointer_c.qp_questId_uid, questPointer_c)
                },
                () => {},
                (questId_uid) => {
                    this.$delete(this.server_currentUserLovedQuests_byQuestId_c,questId_uid)
                })
        },
        deactivated(){
            if(this.server_creatorData_c){
                serverPre_cl_currentUserLovedQuests_remove_f(this.$options.name, this.server_creatorData_c.ud_userId_uid)
            }
        }
    }
</script>

<style scoped>

</style>